import { useEffect, useState } from 'react';

import { DatePicker } from '../DatePicker';

export interface ActionBarDateRangeFilterProps {
  onChange: (value: [Date, Date] | null) => void;
  value: [Date, Date] | null;
  disabled?: boolean;
  maxDate?: Date;
  minDate?: Date;
  placeholder?: string;
}

export default function ActionBarDateRangeFilter(props: ActionBarDateRangeFilterProps) {
  const { onChange, value, maxDate, minDate, disabled = false, placeholder } = props;

  const [externalValueStart, externalValueEnd] = value ?? [null, null];

  const [internalValue, setInternalValue] = useState<[Date | null, Date | null]>([
    value?.[0] ?? null,
    value?.[1] ?? null,
  ]);

  const handleChange = ([start, end]: [Date | null, Date | null]) => {
    setInternalValue([start, end]);
    if (start && end) {
      onChange([start, end]);
    }
  };

  useEffect(() => {
    setInternalValue([externalValueStart ?? null, externalValueEnd ?? null]);
  }, [externalValueStart, externalValueEnd]);

  return (
    <DatePicker
      selectsRange
      startDate={internalValue?.[0]}
      endDate={internalValue?.[1]}
      onChange={handleChange}
      minDate={minDate}
      maxDate={maxDate}
      inputProps={{ size: 'md' }}
      disabled={disabled}
      placeholderText={placeholder}
      clampDateOutOfRange
      // TODO (@walter-24) input에 표시할 prefix text 지정할 수 있어야 함
      // TODO (@walter-24) onOpen, onClose 인터페이스 필요
      // FIXME (@walter-24) DateFilter나 DateRangeFilter가 두 개 이상 있으면, Popover가 표시되지 않는 버그
    />
  );
}
